import React, { useRef } from "react";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";

const CountdownModule = (props) => {
  const [time, setTime] = useState("");
  const [clear, setClear] = useState(false);
  const timerRef = useRef();

  const { settings } = props;
  const { datetime, color, numberSize, textSize } = settings;

  useEffect(() => {
    const t = new Date();
    const { eventId, lang } = props;

    timerRef.current = setInterval(() => countdown(t.setSeconds(t.getSeconds() + 1)), 1000);
    init(eventId, "DigitalMeeting.Countdown", lang || "swe");
    return () => clearInterval(timerRef.current);
  }, []);
  useEffect(() => {
    const t = new Date();
    const { eventId, lang } = props;
    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => countdown(t.setSeconds(t.getSeconds() + 1)), 1000);
    init(eventId, "DigitalMeeting.Countdown", lang || "swe");
  }, [datetime]);

  const countdown = (currentTime) => {
    if (clear) return;
    let secondsLeft = (new Date(datetime) - new Date(currentTime)) / 1000;
    var delta = Math.abs(datetime - currentTime) / 1000;
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    var seconds = Math.floor(delta % 60);

    if (secondsLeft <= 0) {
      setTime({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      });
      /*  setClear(true); */
      return;
    }

    setTime({
      days: days < 10 && days > 0 ? "0" + days : days,
      hours: hours < 10 && hours > 0 ? "0" + hours : hours,
      minutes: minutes < 10 && minutes > 0 ? "0" + minutes : minutes,
      seconds: seconds < 10 && seconds > 0 ? "0" + seconds : seconds,
    });
  };

  if (clear) return null;

  const { template } = props;

  if (!template) return null;

  const { content, subtitle } = template.content;

  const timeBadgeStyle = {
    /*    backgroundColor: content.backgroundColor, */
    color,
    fontSize: numberSize,
    fontFamily: subtitle.fontFamily,
  };
  const textStyle = {
    color,
    fontFamily: subtitle.fontFamily,
  };

  if (!time) return null;

  const { days, hours, minutes, seconds } = time;

  return (
    <div className="countdown-wrapper" style={{ textAlign: "center", width: "100%" }}>
      <div className="time-badges">
        <div style={textStyle}>
          <div className="time smooth-shadow" style={timeBadgeStyle}>
            {days}
          </div>
          <span style={{ fontSize: textSize }}>
            <EventLabel2 name="Days" groupName="DigitalMeeting.Countdown" />
          </span>
        </div>
        <div style={textStyle}>
          <div className="time smooth-shadow" style={timeBadgeStyle}>
            {hours}
          </div>
          <span style={{ fontSize: textSize }}>
            <EventLabel2 name="Hours" groupName="DigitalMeeting.Countdown" />
          </span>
        </div>
        <div style={textStyle}>
          <div className="time smooth-shadow" style={timeBadgeStyle}>
            {minutes}
          </div>
          <span style={{ fontSize: textSize }}>
            <EventLabel2 name="Minutes" groupName="DigitalMeeting.Countdown" />
          </span>
        </div>
        <div style={textStyle}>
          <div className="time smooth-shadow" style={timeBadgeStyle}>
            {seconds}
          </div>{" "}
          <span style={{ fontSize: textSize }}>
            <EventLabel2 name="Seconds" groupName="DigitalMeeting.Countdown" />
          </span>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(CountdownModule);
